/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_LoadingInputs */

const en_ui_loading = /** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading`)
};

/** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */
const ar_ui_loading = en_ui_loading;

/** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */
const he_ui_loading = en_ui_loading;

/** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */
const ur_ui_loading = en_ui_loading;

/** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */
const es_ui_loading = en_ui_loading;

/** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */
const fr_ui_loading = en_ui_loading;

/** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */
const de_ui_loading = en_ui_loading;

/** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */
const pt_ui_loading = en_ui_loading;

/** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */
const hi_ui_loading = en_ui_loading;

/** @type {(inputs: Ui_LoadingInputs) => LocalizedString} */
const bn_ui_loading = en_ui_loading;

/**
* | output |
* | --- |
* | "Loading" |
*
* @param {Ui_LoadingInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_loading = /** @type {((inputs?: Ui_LoadingInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_LoadingInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_loading(inputs)
	if (locale === "he") return he_ui_loading(inputs)
	if (locale === "ur") return ur_ui_loading(inputs)
	if (locale === "es") return es_ui_loading(inputs)
	if (locale === "fr") return fr_ui_loading(inputs)
	if (locale === "de") return de_ui_loading(inputs)
	if (locale === "pt") return pt_ui_loading(inputs)
	if (locale === "hi") return hi_ui_loading(inputs)
	if (locale === "bn") return bn_ui_loading(inputs)
	return /** @type {LocalizedString} */ ("Loading")
});